// frontend/src/components/FinanceReport/Accounting/components/accounts/suppliers/SupplierDocumentsModal.jsx

import { useMemo } from "react";

function formatDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("ru-RU");
}

export default function SupplierDocumentsModal({ open, item, onClose }) {
  const documents = useMemo(() => item?.documents || [], [item]);

  if (!open || !item) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="my-8 w-full max-w-xl rounded-2xl bg-white p-6 shadow-2xl">
        <div className="mb-4 flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Документы #{item.id}
            </h2>
            <p className="mt-1 text-xs text-slate-500">
              {item.supplier_name || `Поставщик #${item.supplier}`} ·{" "}
              {item.type === "income" ? "Приход" : "Расход"} · {item.amount} ¥
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-2 py-1 text-slate-500 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        {documents.length === 0 ? (
          <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center">
            <div className="text-3xl">📭</div>
            <p className="mt-2 text-sm text-slate-600">К этой записи нет документов.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3"
              >
                <div className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-slate-100 text-lg">
                  📄
                </div>
                <div className="min-w-0 flex-1">
                  <a
                    href={doc.file_url || doc.file}
                    target="_blank"
                    rel="noreferrer"
                    className="block truncate text-sm font-medium text-blue-700 hover:underline"
                  >
                    {doc.original_name || `Документ #${doc.id}`}
                  </a>
                  <p className="text-xs text-slate-500">
                    {formatDate(doc.uploaded_at)}
                  </p>
                </div>
                <div className="flex shrink-0 gap-2">
                  <a
                    href={doc.file_url || doc.file}
                    download={doc.original_name || `document-${doc.id}`}
                    className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
                  >
                    ⬇ Скачать
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}